module.exports = __webpack_public_path__ + "img/9.6eb28a2a.png";